import { createFileRoute } from "@tanstack/react-router";
import { JtbdPicker } from "@/app/onboarding-first-win/steps/jtbd-picker/jtbd-picker";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/onboarding/"
)({
  component: JtbdPicker,
});
